import type {OrderItem} from '../../../types/order-item'
import {buildOrderItem} from '../../../types/order-item'

const normalizeOrderItems = function (input: Object): OrderItem {
  return {
    ...buildOrderItem,
    id: input.id,
    orderItemType: input.orderItemType,
    engravedIdString: input.engravedIdString,
    tariffName: input.tariffName,
    dateEffective: input.dateEffective,
    orderStatus: input.orderStatus
  }
}

export {
  normalizeOrderItems
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/order-item-normalizer.js